import { Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-association-msbaseurl-form',
  templateUrl: './association-msbaseurl-form.component.html',
  styleUrls: ['./association-msbaseurl-form.component.css']
})
export class AssociationMsbaseurlFormComponent implements OnInit {
  form: FormGroup;
  invalidSubmit: boolean;
  @Input() selectedAssociation: any;
  @Output() msBaseUrlChanged: EventEmitter<string> = new EventEmitter();

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    if (this.selectedAssociation.msBaseUrl) {
      this.form = this.fb.group({
        msBaseUrl: [this.selectedAssociation.msBaseUrl, Validators.required]
      });
    } else if (this.selectedAssociation.ms_base_url) {
      this.form = this.fb.group({
        msBaseUrl: [this.selectedAssociation.ms_base_url, Validators.required]
      });
    } else {
      this.form = this.fb.group({
        msBaseUrl: ['', Validators.required]
      });
    }
  }

  save() {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return
    }
    this.invalidSubmit = false;
    this.msBaseUrlChanged.emit(this.form.get('msBaseUrl').value);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/associations-management/associations/association-msbaseurl-form/association-msbaseurl-form.component.ts